export const getBannockburnData = () => ({
  name: "Bannockburn",
  region: "Central Otago",
  country: "Nouvelle-Zélande",
  description: "Bannockburn est une zone viticole traditionnelle de Central Otago, réputée pour ses vins de Pinot Noir de qualité. Située dans une vallée protégée, cette sous-région bénéficie d'un climat continental unique avec des étés chauds et des hivers froids.",
  type: "subregion",
  area: "400 ha",
  production: "0.03 million hectolitres",
  climate: "Climat continental avec étés chauds et secs, hivers froids, amplitudes thermiques importantes",
  soil: "Sols schisteux, excellente drainage, faible fertilité",
  characteristics: {
    climate: "Climat continental avec étés chauds et secs, hivers froids, amplitudes thermiques importantes",
    soil: "Sols schisteux, excellente drainage, faible fertilité",
    viticulture: "Viticulture d'altitude, rendements limités, qualité privilégiée"
  },
  wineStyles: {
    red: "Pinot Noir élégant avec tanins fins, notes de fruits rouges et épices",
    white: "Chardonnay sec et minéral avec belle acidité",
    rosé: "Rosés délicats et fruités, parfaits pour l'apéritif"
  },
  history: "La viticulture à Bannockburn a commencé dans les années 1980 avec les premiers vignobles commerciaux. Le Pinot Noir est rapidement devenu le cépage emblématique de la zone, produisant des vins avec une personnalité unique grâce au climat continental et aux sols schisteux. Aujourd'hui, Bannockburn est reconnu comme l'un des meilleurs terroirs de Central Otago.",
  foodPairing: "Viandes rouges, gibier, fromages affinés, plats d'hiver, cuisine locale",
  grapeVarieties: [
    {
      name: "Pinot Noir",
      percentage: "85%",
      description: "Cépage emblématique de Bannockburn, produisant des vins élégants avec des tanins fins",
      characteristics: "Élégant, tanins fins, fruits rouges",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Chardonnay",
      percentage: "10%",
      description: "Cépage blanc principal, produisant des vins secs et minéraux",
      characteristics: "Sec, minéral, acidité vive",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Pinot Gris",
      percentage: "3%",
      description: "Cépage blanc produisant des vins aromatiques et texturés",
      characteristics: "Aromatique, texturé, notes d'épices",
      wineStyles: "Sec à demi-sec, aromatique"
    },
    {
      name: "Riesling",
      percentage: "2%",
      description: "Cépage blanc produisant des vins secs et aromatiques",
      characteristics: "Sec, aromatique, acidité vive",
      wineStyles: "Sec à demi-sec, aromatique"
    }
  ],
  statistics: {
    totalArea: "400 ha",
    production: "0.03 million hectolitres",
    wineries: "15+ domaines",
    exportPercentage: "50%"
  },
  viticulture: "La viticulture à Bannockburn se caractérise par l'attention aux détails et la recherche de la qualité. Les rendements sont limités pour préserver l'intensité aromatique et la concentration. La viticulture d'altitude et les amplitudes thermiques importantes contribuent à la complexité des vins.",
  winemaking: "La vinification se fait principalement en fûts de chêne pour ajouter de la complexité. La macération pré-fermentaire et l'élevage en barriques sont courants. La fermentation malolactique est souvent pratiquée pour adoucir l'acidité.",
  terroir: "Bannockburn est caractérisé par ses sols schisteux et son climat continental. La vallée protégée offre des conditions idéales pour la maturation des raisins, avec des étés chauds et secs et des nuits fraîches. Les amplitudes thermiques importantes contribuent à la complexité aromatique des vins.",
  mapAreas: [
    { region: "Bannockburn", x: 169.5, y: -45.0, color: "#4B164C", size: 4 }
  ]
}); 